import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import AOS from "aos";
import "aos/dist/aos.css";
import "@/styles/index.scss"; // global css
import "./plugins/element.js";
import i18n from "./i18n";
import * as VueGoogleMaps from 'vue2-google-maps'
// import VGoogleTranslate from "v-google-translate";

Vue.config.productionTip = false;
// Vue.use(VGoogleTranslate);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDGVHFP9OWuyj6S85jeo5_xblxdW-M5QmA',
    libraries: 'places',
    installComponents: true
  }
});


fetch(process.env.BASE_URL + "config/home.json")
  .then(response => response.json())
  .then(info => {
    Vue.prototype.$info = info;
    new Vue({
      created() {
        AOS.init({
          duration: 800
        });
      },
      i18n,
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  });
